import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class RelatorioResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  bairros() {
    return this.http.get(`${this.resource}/bairro`, { responseType: 'blob' });
  }

  usuarios() {
    return this.http.get(`${this.resource}/usuario`, { responseType: 'blob' });
  }

  contratos(params) {
    return this.http.get(`${this.resource}/contratos`, { params, responseType: 'blob' });
  }

  veiculos(params) {
    return this.http.get(`${this.resource}/veiculos`, { params, responseType: 'blob' });
  }

  veiculosAusenciaDados(params) {
    return this.http.get(`${this.resource}/veiculos/ausencia_dados`, { params, responseType: 'blob' });
  }

  frequenciaVeiculos(params) {
    return this.http.get(`${this.resource}/frequencia_veiculo`, { params, responseType: 'blob' });
  }

  veiculosSecretaria(params) {
    return this.http.get(`${this.resource}/veiculo_secretaria`, { params, responseType: 'blob' });
  }

  motoristaSemFoto() {
    return this.http.get(`${this.resource}/motoristas/sem_foto`, { responseType: 'blob' });
  }
}

const resource = 'relatorio';

const moduloHttp = new RelatorioResourceHttp(clientHttp, prefixBase + resource);

export default moduloHttp;
